import { serviceName } from '../resources/serviceConstants';
import { KPI, KPI_CATEGORY_MASTER, KPI_MASTER, KPI_TARGET_FORMAT, KPI_PERFORMANCE_CYCLE } from '../resources/endPoint';

export const getKpi = (data) => {
  // API call to fetch KPI details

  return {
    // eslint-disable-next-line max-len
    url: KPI + '/?department=' + data.department + '&vertical=' + data.vertical + '&designation=' + data.designation + '&period=' + data.performancePeriod,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getKpiCateroryList = () => {
  // API call to fetch KPI category details

  return {
    url: KPI_CATEGORY_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getKpiTargetFormat = () => {
  // API call to fetch KPI Target Foramt details

  return {
    url: KPI_TARGET_FORMAT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getKpiMasterDetails = (id) => {
  // API call to fetch KPI Master details

  return {
    url: KPI_MASTER + '?kpi-category-id=' + id,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const setKpi = (payload) => {
  // API call to add KPI data

  return {
    url: KPI,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
    payload,
  };
};

export const updateKpiDetails = (data) => {

  return {
    url: KPI,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const kpiPerformanceCycle = () => {

  return {
    url: KPI_PERFORMANCE_CYCLE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};
